import React from "react";
import JobBoardItem from "../JobBoardItem";

export default function PendingOrders({
  selectedLocation,
  searchText,
  productTypesData,
  refreshStatusList,
  setRefreshStatusList,
  dateFrom,
  dateTo,
  // The Approved tab is this list for "approved" (user, 2026-10-27).
  woStatus = "pending",
}) {
  /* ******************** All States ************************* */
  const API_CALL = "/job-board/pending-orders";

  /* ******************** All Functions ************************* */

  /* ******************** All UseEffects ************************* */

  return (
    <div>
      <div
        className="d-flex flex-wrap scrollbar-hidee gap-2 align-items-top mt-5 justify-content-between overflow-auto "
        style={{ height: "89vh" }}
      >
        {productTypesData &&
          productTypesData?.map((item) => (
            <div
              key={item?.id}
              className="bg-white flex-grow-1 overflow-hidden pb-1 custom-shadow-sm custom-border-radius "
              style={{ width: "45%", position: "relative" }}
            >
              <JobBoardItem
                woStatus={woStatus}
                API_CALL={API_CALL}
                selectedLocation={selectedLocation}
                filterText={searchText}
                productType={item}
                refreshStatusList={refreshStatusList}
                setRefreshStatusList={setRefreshStatusList}
                dateFrom={dateFrom}
                dateTo={dateTo}
              />
            </div>
          ))}
      </div>
    </div>
  );
}
